import type { PinType } from './analytics';
import type { CommentPinType } from '../types';

export const COMMENT_PIN_TYPE_MAP: Record<PinType, CommentPinType> = {
  spot: 'parking_spot',
  seeker: 'seeker_pin',
  rent: 'rent_pin',
};

export function attachInterestClickHandler(root: ParentNode = document): void {
  root.addEventListener('click', (e: Event) => {
    const btn = (e.target as HTMLElement | null)?.closest<HTMLElement>('button[data-interest]');
    if (!btn) return;
    const spotId = btn.getAttribute('data-spot-id');
    if (!spotId) return;
    window.dispatchEvent(
      new CustomEvent('parksy:open-interest', { detail: { spotId } })
    );
  });
}

export function attachCommentsClickHandler(root: ParentNode = document): void {
  root.addEventListener('click', (e: Event) => {
    const btn = (e.target as HTMLElement | null)?.closest<HTMLElement>('button[data-comments]');
    if (!btn) return;
    const pinType = btn.getAttribute('data-pin-type') as PinType | null;
    const pinId = btn.getAttribute('data-pin-id');
    if (!pinType || !pinId) return;
    if (pinType !== 'spot' && pinType !== 'seeker' && pinType !== 'rent') return;
    window.dispatchEvent(
      new CustomEvent('parksy:open-comments', {
        detail: { pinType, pinId, pinTypeApi: COMMENT_PIN_TYPE_MAP[pinType] },
      })
    );
  });
}
